// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_bi-0";
export var optionCard = "_bi-1";